import React, { useRef, useState } from "react";
  import { IoMdArrowRoundBack } from "react-icons/io";
import { useSelector } from "react-redux";
import Setting from "../../Pages/Setting/Setting";
import "../../assets/styles/Style.css";
import "../Navbar.css";
import "./NavbarStyle.css";

const RenderNavbar = ({ closeModal }) => {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const profileBtnRef = useRef(null);
  const { isCard, title } = useSelector((state) => state.project);

  const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    if (firstName) return firstName.charAt(0).toUpperCase();
    return "U"; 
  };

  const getBackgroundColor = () => "#7c5cff26";

  return (
    <>
      <nav className="w-full h-full Pro_navbarDash flex flex-wrap justify-between items-center">

        <div className="flex items-center gap-3 min-w-0">
          <button className="arrowIcon flex items-center opacity-30 hover:opacity-100"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              closeModal?.();
            }}
          >
            <IoMdArrowRoundBack size={20} />
          </button>

          <div className="h-[17px] w-[1px] bg-[#ffffff1a]" />

          <div className="flex items-center gap-2.5 hedertext min-w-0">
            <span className="w-2 h-2 rounded-full bg-[#7c5cff] shadow-[0_0_8px_rgba(124,92,255,.8)] circleIcon" />
            <span className="hedertext font-semibold text-[14px]">
              {isCard ? "Card" : "Scroll"}
            </span>
            <span className="hedertext">/</span>
            <span className="text-[#625e83] font-normal">Render</span>
          </div>
        </div>

        <div className="font-semibold text-[14px] text-[#f0eeff] tracking-tight truncate px-3">
          {title?.toUpperCase()}
        </div>

        <div className="flex items-center gap-3">
          <span className="text-[13px] text-[#a8a4c8] hidden sm:block truncate max-w-[180px]">
            {userInfo?.email}
          </span>
          <button
            ref={profileBtnRef}
            type="button"
            className="w-[35px] h-[35px] flex justify-center items-center border-[1px] border-[#7c5cff4d] hover:bg-[#7c5cff40] rounded-full transition-colors"
            onClick={() => setIsSettingOpen((open) => !open)}
            style={{ backgroundColor: getBackgroundColor() }}
            aria-expanded={isSettingOpen}
            aria-haspopup="true"
          >
            <div className="flex justify-center items-center text-[#c4b2ff] text-xl font-body w-[35px] h-[35px] rounded-full">
              <span className="font-body text-[#c4b2ff] text-lg text-center">
                {getUserInitials()}
              </span>
            </div>
          </button>
        </div>
      </nav>

      <Setting
        isSettingOpen={isSettingOpen}
        setIsSettingOpen={setIsSettingOpen}
        anchorRef={profileBtnRef}
      />
    </>
  );
};

export default RenderNavbar;
